import React from 'react';

import styled from 'styled-components';

import Icon from 'common/Icons/Icon';
import Dropdown from 'components/lib/Dropdown';

import { MY_COMMUNITIES_RATE_GAP_THRESHOLD_OPTIONS } from './constants';

const MENU_WIDTH = 190;

const Trigger = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--text-primary);
  white-space: nowrap;
  cursor: pointer;
`;

const Value = styled.span`
  color: var(--dark-blue);
`;

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const RateGapThresholdSelect = ({ value, onChange }: Props) => {
  const items = MY_COMMUNITIES_RATE_GAP_THRESHOLD_OPTIONS.map((option) => ({
    key: String(option.value),
    label: option.label,
    onClick: () => onChange(option.value),
  }));

  const selectedLabel = MY_COMMUNITIES_RATE_GAP_THRESHOLD_OPTIONS.find((option) => option.value === value)?.label ?? '';

  return (
    <Dropdown
      menu={{ items, selectable: true, selectedKeys: [String(value)] }}
      trigger={['click']}
      menuWidth={MENU_WIDTH}
    >
      <Trigger data-test-id="my-communities-rate-gap-threshold-select">
        Rate Gap: <Value>{selectedLabel}</Value>
        <Icon src="/icons/dropdown-caret-down-blue.svg" />
      </Trigger>
    </Dropdown>
  );
};

export default RateGapThresholdSelect;
